import { Box, Typography } from '@mui/material';
import { MatchingPropFieldText } from './edit-fields/MatchingPropFieldText';
import { MatchingPropFieldNumber } from './edit-fields/MatchingPropFieldNumber';
import { MatchingPropFieldCheckbox } from './edit-fields/MatchingPropFieldCheckbox';
import { MatchingPropFieldTextShow } from './show-fields/MatchingPropFieldTextShow';
import { MatchingPropFieldNumberShow } from './show-fields/MatchingPropFieldNumberShow';
import { MatchingPropFieldCheckboxShow } from './show-fields/MatchingPropFieldCheckboxShow';
import { MatchingPropFieldSelect } from './edit-fields/MatchingPropFieldSelect';
import { MatchingPropFieldSelectShow } from './show-fields/MatchingPropFieldSelectShow';
import { MatchingPropLeadFieldCheckbox } from './edit-lead-fields/MatchingPropLeadFieldCheckbox';
import { MatchingPropLeadFieldNumber } from './edit-lead-fields/MatchingPropLeadFieldNumber';
import { MatchingPropLeadFieldSelect } from './edit-lead-fields/MatchingPropLeadFieldSelect';
import { MatchingPropLeadFieldText } from './edit-lead-fields/MatchingPropLeadFieldText';
import { MatchingPropLeadFieldTextShow } from './show-lead-fields/MatchingPropLeadFieldTextShow';
import { MatchingPropLeadFieldNumberShow } from './show-lead-fields/MatchingPropLeadFieldNumberShow';
import { MatchingPropLeadFieldCheckboxShow } from './show-lead-fields/MatchingPropLeadFieldCheckboxShow';
import { MatchingPropLeadFieldSelectShow } from './show-lead-fields/MatchingPropLeadFieldSelectShow';

export const MatchingPropertieShow = ({
  property,
  isEditMode,
  onChange,
  isLead,
  required,
  size,
}) => {
  const { publicLabel, value, type, label } = property;

  const propEditMap = {
    text: isLead ? MatchingPropLeadFieldText : MatchingPropFieldText,
    number: isLead ? MatchingPropLeadFieldNumber : MatchingPropFieldNumber,
    checkbox: isLead
      ? MatchingPropLeadFieldCheckbox
      : MatchingPropFieldCheckbox,
    select: isLead ? MatchingPropLeadFieldSelect : MatchingPropFieldSelect,
  };
  const EditComponent = propEditMap[type];

  const propShowMap = {
    text: isLead ? MatchingPropLeadFieldTextShow : MatchingPropFieldTextShow,
    number: isLead
      ? MatchingPropLeadFieldNumberShow
      : MatchingPropFieldNumberShow,
    checkbox: isLead
      ? MatchingPropLeadFieldCheckboxShow
      : MatchingPropFieldCheckboxShow,
    select: isLead
      ? MatchingPropLeadFieldSelectShow
      : MatchingPropFieldSelectShow,
  };
  const ShowComponent = propShowMap[type];

  if (isEditMode && EditComponent)
    return (
      <EditComponent
        property={property}
        onChange={(data) => onChange({ data })}
        required={required}
        size={size}
      />
    );

  if (ShowComponent) return <ShowComponent property={property} />;
  return (
    <Box>
      <Typography fontWeight={600}>{`${publicLabel || label}: ${
        value || '-'
      }`}</Typography>
    </Box>
  );
};
